<template>
  <div>
    <div>
      <div v-if="pageLoading" class="text-center" style="padding: 80px 0;">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Carregando...</span>
        </div>
        <p class="mt-2">Carregando produtos...</p>
      </div>

      <template v-else>
        <div class="d-flex justify-content-between align-items-center mb-1">
          <h3 class="mb-0">Produtos</h3>
          <router-link to="/products/add" class="btn btn-primary">Novo Produto</router-link>
        </div>

        <div class="card crud-filters">
          <button
            type="button"
            class="btn-filters-toggle d-md-none"
            @click="filtersOpen = !filtersOpen"
          >
            <span>Filtros</span>
            <span class="chevron" :class="{ open: filtersOpen }">▾</span>
          </button>
          <div class="card-body" :class="{ 'card-body-mobile-open': filtersOpen }">
            <div class="row">
              <div class="col-md-3">
                <label>Modelo</label>
                <input type="text" class="form-control" v-model="filters.product_model_name" placeholder="Buscar por modelo...">
              </div>
              <div class="col-md-3">
                <label>Patrimônio</label>
                <input type="tel" class="form-control" v-model="filters.barcode" placeholder="Digite ou escaneie o patrimônio">
              </div>
              <div class="col-md-3">
                <label>Categoria</label>
                <v-select
                  v-model="filters.product_category_id"
                  :options="categories"
                  :reduce="(c) => c.id"
                  label="name"
                  placeholder="Selecione"
                ></v-select>
              </div>
              <div class="col-md-3">
                <label>Fabricante</label>
                <v-select
                  v-model="filters.manufacturer_id"
                  :options="manufacturers"
                  :reduce="(m) => m.id"
                  label="name"
                  placeholder="Selecione"
                ></v-select>
              </div>
              <div class="col-md-3 mt-2">
                <label>Status</label>
                <v-select
                  v-model="filters.status"
                  :options="statusOptions"
                  :reduce="(s) => s.id"
                  label="text"
                  placeholder="Selecione"
                ></v-select>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-12">
                <button class="btn btn-primary" @click="applyFilters">Filtrar</button>
                <button class="btn btn-secondary ml-2" @click="clearFilters">Limpar filtros</button>
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-0 crud-table-card">
          <div class="row" v-if="loading">
            <div class="col-md-12">
              <div class="text-center" style="padding: 50px;">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Carregando...</span>
                </div>
                <p class="mt-2">Carregando produtos...</p>
              </div>
            </div>
          </div>

          <div v-else class="table-responsive">
            <table class="table table-striped table-bordered table-hover crud-table">
              <thead>
                <tr>
                  <th @click="sortBy('id')" class="sortable">
                    ID
                    <i class="fas" :class="sortIconClass('id')"></i>
                  </th>
                  <th>Modelo</th>
                  <th>Patrimônio</th>
                  <th>Categoria</th>
                  <th>Fabricante</th>                  
                  <th @click="sortBy('status')" class="sortable">
                    Status
                    <i class="fas" :class="sortIconClass('status')"></i>
                  </th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!items.length">
                  <td colspan="7" class="text-center py-4">Nenhum registro encontrado</td>
                </tr>

                <tr v-for="item in items" :key="item.id">
                  <td data-label="ID">{{ item.id }}</td>
                  <td data-label="Modelo">
                    {{ item.product_model ? item.product_model.name : "-" }}
                  </td>
                  <td data-label="Código">{{ item.barcode || "-" }}</td>
                  <td data-label="Categoria">
                    {{ item.category ? item.category.name : "-" }}
                  </td>
                  <td data-label="Fabricante">
                    {{ item.manufacturer ? item.manufacturer.name : "-" }}
                  </td>
                  <td data-label="Status" class="text-center">
                    <span class="soft-badge" :class="statusBadgeClass(item.status)">
                      {{ statusLabel(item.status) }}
                    </span>
                  </td>
                  <td data-label="Ações">
                    <router-link
                      :to="'/products/edit/' + item.id"
                      class="btn btn-crud edit margin-crud"
                      title="Editar"
                    >
                      <i class="fas fa-pencil-alt"></i>
                    </router-link>
                    <button
                      class="btn btn-crud delete margin-crud"
                      title="Deletar"
                      @click="destroy(item)"
                    >
                      <i class="far fa-trash-alt"></i>
                    </button>
                    <button
                      class="btn btn-crud view margin-crud"
                      title="Ver outros produtos desse Modelo"
                      @click="openStockModal(item)"
                    >
                      <i class="far fa-clone"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="pagination-bar">
            <div class="per-page-selector">
              Registros por página:
              <select class="form-control d-inline-block w-auto ml-1" v-model.number="pagination.perPage" @change="changePerPage">
                <option v-for="v in pagination.perPageOptions" :key="v" :value="v">{{ v }}</option>
              </select>
            </div>

            <div class="col-md-6 mt-1 mx-auto d-flex justify-content-center align-items-center">
              <pagination
                :records="totalItems"
                :options="paginationOptions"
                :per-page="pagination.perPage"
                @paginate="onPaginate"
              ></pagination>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div class="modal fade" id="stockByModelModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Estoque — Modelo: {{ stockModalModelName }}</h5>
            <button type="button" class="close" data-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="stockModalLoading" class="text-center" style="padding: 30px;">
              <div class="spinner-border text-primary" role="status"></div>
            </div>
            <div v-else class="table-responsive">
              <table class="table table-striped table-bordered crud-table">
                <thead>
                  <tr>
                    <th>Patrimônio</th>
                    <th>Fabricante</th>
                    <th>Fornecedor</th>
                    <th>Unidade Atual</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!stockModalItems.length">
                    <td colspan="5" class="text-center py-4">Nenhum outro produto encontrado com esse Modelo</td>
                  </tr>
                  <tr v-for="stockItem in stockModalItems" :key="stockItem.id">
                    <td data-label="Patrimônio">{{ stockItem.barcode || "-" }}</td>
                    <td data-label="Fabricante">{{ stockItem.manufacturer ? stockItem.manufacturer.name : "-" }}</td>
                    <td data-label="Fornecedor">{{ stockItem.supplier ? stockItem.supplier.name : "-" }}</td>
                    <td data-label="Unidade Atual">{{ stockItem.current_unit ? stockItem.current_unit.name : "Sem Unidade" }}</td>
                    <td data-label="Status" class="text-center">
                      <span class="soft-badge" :class="statusBadgeClass(stockItem.status)">
                        {{ statusLabel(stockItem.status) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <strong>Total de produtos: {{ stockModalItems.length }}</strong>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";
import vSelect from "vue-select";

export default {
  components: {
    Pagination,
    vSelect,
  },
  data: function () {
    return {
      pageLoading: true,
      loading: false,
      filtersOpen: false,

      filters: {
        product_model_name: "",
        barcode: "",
        product_category_id: null,
        manufacturer_id: null,
        status: null,
      },

      statusOptions: [
        { id: 1, text: "Em estoque" },
        { id: 2, text: "Em uso" },
        { id: 3, text: "Manutenção" },
        { id: 0, text: "Baixado" },
      ],

      categories: [],
      manufacturers: [],

      stockModalItems: [],
      stockModalModelName: "",
      stockModalLoading: false,

      items: [],
      totalItems: 0,
      pagination: {
        page: 1,
        perPage: 10,
        perPageOptions: [10, 25, 50, 100],
      },
      paginationOptions: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      sort: {
        column: "id",
        ascending: false,
      },
    };
  },

  async mounted() {
    this.pageLoading = true;
    try {
      await Promise.all([
        this.getCategories(),
        this.getManufacturers(),
        this.fetchItems(),
      ]);
    } catch (e) {
      console.error(e);
    } finally {
      this.pageLoading = false;
    }
  },

  methods: {
    getCategories() {
      const self = this;
      return axios
        .get(self.$store.state.api + "product_categories?paginated=false")
        .then((response) => {
          self.categories = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getManufacturers() {
      const self = this;
      return axios
        .get(self.$store.state.api + "manufacturers?paginated=false")
        .then((response) => {
          self.manufacturers = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    fetchItems() {
      const self = this;
      const f = this.filters;

      let qs = "";
      if (f.product_model_name) qs += "productModel[name]=" + encodeURIComponent(f.product_model_name) + "&";
      if (f.barcode) qs += "barcode=" + encodeURIComponent(f.barcode) + "&";
      if (f.product_category_id) qs += "product_category_id=" + f.product_category_id + "&";
      if (f.manufacturer_id) qs += "manufacturer_id=" + f.manufacturer_id + "&";
      if (f.status !== null && f.status !== undefined) qs += "status=" + f.status + "&";

      qs += "with[]=category&with[]=manufacturer&with[]=productModel&";
      qs += "paginated=true&limit=" + this.pagination.perPage + "&page=" + this.pagination.page + "&";
      qs += (this.sort.ascending ? "orderByAsc=" : "orderByDesc=") + this.sort.column;

      self.loading = true;
      return axios
        .get(self.$store.state.api + "products?" + qs)
        .then((response) => {
          self.items = response.data.data;
          self.totalItems = response.data.count;
          self.loading = false;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.loading = false;
        });
    },

    applyFilters() {
      this.pagination.page = 1;
      this.fetchItems();
    },

    clearFilters() {
      this.filters = {
        product_model_name: "",
        barcode: "",
        product_category_id: null,
        manufacturer_id: null,
        status: null,
      };
      this.applyFilters();
    },

    onPaginate(page) {
      this.pagination.page = page;
      this.fetchItems();
    },

    changePerPage() {
      this.pagination.page = 1;
      this.fetchItems();
    },

    sortBy(column) {
      if (this.sort.column === column) {
        this.sort.ascending = !this.sort.ascending;
      } else {
        this.sort.column = column;
        this.sort.ascending = true;
      }
      this.fetchItems();
    },

    sortIconClass(column) {
      if (this.sort.column !== column) return "fa-sort";
      return this.sort.ascending ? "fa-chevron-up" : "fa-chevron-down";
    },

    statusLabel(status) {
      const labels = { 1: "Em estoque", 2: "Em uso", 3: "Manutenção", 0: "Baixado" };
      return labels[status] ?? "Baixado";
    },

    statusBadgeClass(status) {
      const classes = {
        1: "badge-success",
        2: "badge-primary",
        3: "badge-warning",
        0: "badge-danger",
      };
      return classes[status] ?? "badge-secondary";
    },

    openStockModal(item) {
      const self = this;

      self.stockModalModelName = item.product_model ? item.product_model.name : "Sem Modelo";
      self.stockModalItems = [];
      self.stockModalLoading = true;

      $("#stockByModelModal").modal("show");

      axios
        .get(
          self.$store.state.api +
            "products?paginated=false&product_model_id=" +
            item.product_model_id +
            "&with[]=manufacturer&with[]=supplier&with[]=currentUnit"
        )
        .then((response) => {
          self.stockModalItems = response.data.data;
          self.stockModalLoading = false;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.stockModalLoading = false;
        });
    },

    destroy(item) {
      const self = this;
      swal({
        title: "Deseja deletar o registro?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: { text: "Não", value: "cancel", className: "btn-danger" },
          confirm: { text: "Sim", value: "confirm" },
        },
      }).then((value) => {
        if (value !== "confirm") {
          swal("Cancelado", "O registro não foi excluído!", "info");
          return;
        }

        axios
          .delete(self.$store.state.api + "products/" + item.id)
          .then(() => {
            swal("Sucesso", "Registro excluído com sucesso!", "success");
            self.fetchItems();
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
      });
    },
  },
};
</script>

<style scoped>
.crud-table {
  margin-bottom: 0;
  font-size: 0.95rem;
  width: 100%;
  table-layout: fixed;
}

.crud-table thead th.sortable {
  cursor: pointer;
  user-select: none;
}

.crud-table td,
.crud-table th {
  padding: 0.9rem 0.75rem;
  white-space: normal;
  overflow-wrap: break-word;
}

.crud-table thead th {
  background-color: #283046 !important;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  vertical-align: middle;
  border-left: none !important;
  border-right: none !important;
  font-size: 0.80rem;
}

.crud-table tbody tr,
.crud-table tbody tr:nth-of-type(odd),
.crud-table tbody tr:nth-of-type(even) {
  background-color: #132133 !important;
}

.crud-table tbody td {
  background-color: #132133 !important;
}

.crud-table .soft-badge {
  display: inline-block;
  white-space: normal;
  padding: 0.5em 0.75em;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.2;
  border-radius: 6px;
  border: 1px solid transparent;
}

.crud-table .soft-badge.badge-danger {
  background-color: rgba(234, 84, 85, 0.12) !important;
  border-color: rgba(234, 84, 85, 0.4);
  color: #d97577 !important;
}

.crud-table .soft-badge.badge-warning {
  background-color: rgba(255, 159, 67, 0.12) !important;
  border-color: rgba(255, 159, 67, 0.4);
  color: #d99a5c !important;
}

.crud-table .soft-badge.badge-success {
  background-color: rgba(40, 199, 111, 0.12) !important;
  border-color: rgba(40, 199, 111, 0.4);
  color: #5cb98a !important;
}

.crud-table .soft-badge.badge-primary {
  background-color: rgba(115, 103, 240, 0.12) !important;
  border-color: rgba(115, 103, 240, 0.4);
  color: #8b82df !important;
}

.crud-table .soft-badge.badge-secondary {
  background-color: rgba(130, 134, 139, 0.12) !important;
  border-color: rgba(130, 134, 139, 0.4);
  color: #a9adb3 !important;
}

.crud-table td:last-child {
  text-align: center;
  white-space: nowrap;
}

.margin-crud {
  margin: 0 2px;
}

.pagination-bar {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 16px;
  position: relative;
}

.pagination-bar .per-page-selector {
  position: absolute;
  left: 16px;
  top: 16px;
  display: flex;
  align-items: center;
  height: 38px;
}

.pagination-bar ::v-deep .VuePagination {
  text-align: center;
  margin-bottom: 0;
}

.pagination-bar ::v-deep .VuePagination ul.pagination {
  margin-bottom: 0;
  justify-content: center;
}

.pagination-bar ::v-deep .VuePagination__count {
  margin: 8px 0 0;
}

.crud-filters,
.crud-table-card {
  background: rgba(23, 38, 57, 0.55) !important;
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
}
.crud-filters {
  position: relative;
  z-index: 20;
}

.crud-table-card {
  position: relative;
  z-index: 1;
  border-radius: 6px;
  overflow: hidden;
}

.btn-filters-toggle {
  display: none;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  border: none;
  color: inherit;
  font-weight: 600;
  font-size: 14px;
  padding: 14px 16px;
  cursor: pointer;
}
.btn-filters-toggle .chevron {
  transition: transform .15s;
  color: rgba(255,255,255,.5);
}
.btn-filters-toggle .chevron.open { transform: rotate(180deg); }

/* LIGHT MODE */

body:not(.dark-layout) .crud-page-container {
  background-color: #eef1f6;
}

body:not(.dark-layout) .crud-filters,
body:not(.dark-layout) .crud-table-card {
  background: rgba(255, 255, 255, 0.55) !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

body:not(.dark-layout) .crud-table thead th {
  background-color: rgba(255, 255, 255, 0.45) !important;
}

body:not(.dark-layout) .crud-table tbody tr,
body:not(.dark-layout) .crud-table tbody tr:nth-of-type(odd),
body:not(.dark-layout) .crud-table tbody tr:nth-of-type(even),
body:not(.dark-layout) .crud-table tbody td {
  background-color: rgba(255, 255, 255, 0.35) !important;
}

body:not(.dark-layout) .crud-table .soft-badge.badge-danger { color: #ea5455 !important; }
body:not(.dark-layout) .crud-table .soft-badge.badge-warning { color: #ff9f43 !important; }
body:not(.dark-layout) .crud-table .soft-badge.badge-success { color: #28c76f !important; }
body:not(.dark-layout) .crud-table .soft-badge.badge-primary { color: #7367f0 !important; }
body:not(.dark-layout) .crud-table .soft-badge.badge-secondary { color: #82868b !important; }

/* RESPONSIVO — MOBILE */

@media (max-width: 768px) {
  .btn-filters-toggle { display: flex; }
  .crud-filters .card-body { display: none; }
  .crud-filters .card-body.card-body-mobile-open { display: block; padding-top: 0; }

  .crud-table thead { display: none; }
  .crud-table, .crud-table tbody, .crud-table tr, .crud-table td {
    display: block;
    width: 100% !important;
  }
  .crud-table tr {
    margin-bottom: 14px;
    border-radius: 8px;
    padding: 14px;
    border: 1px solid rgba(255,255,255,.08);
  }

  .crud-table td[data-label]::before {
    content: attr(data-label);
    display: block;
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: .3px;
    text-transform: uppercase;
    color: rgba(255,255,255,.45);
    margin-bottom: 4px;
  }
  .crud-table td[data-label] {
    text-align: left !important;
  }

  .crud-table td:last-child .btn {
    display: inline-block;
    margin: 4px 6px 0 0;
  }

  body:not(.dark-layout) .crud-table td[data-label]::before {
    color: rgba(0,0,0,.45);
  }

  .pagination-bar {
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding-top: 5px;
  }
  .pagination-bar .per-page-selector {
    position: static;
    justify-content: center;
    width: 100%;
  }
  .pagination-bar ::v-deep .VuePagination__count {
    font-size: 12px;
    text-align: center;
  }

  .crud-filters .row.mt-3 > .col-md-12 {
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
  }
  .crud-filters .row.mt-3 .btn {
    flex: 1 1 0;
    margin-left: 0 !important;
    white-space: nowrap;
  }
}
</style>
